// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { environment as prodEnv } from './environment.prod';

export const environment = {
  production: false,
  isMock: true,
  version: prodEnv.version,
  api: {
    host: 'https://ns-plataforma-corretor-api.hmg.marlin.com.br',
    endpoints: {
      methods: {
        autenticacao: {
          autentication: '/api/corretor/token',
          verify: '/api/corretor/token/verify',
        },
        notificacoes: {
          get: {
            quantidade: '/api/corretor/notificacoes/quantidade',
            list: '/api/corretor/notificacoes',
          },
          post: {
            readnotification: '/api/corretor/readnotification',
          },
        },
        corretor: {
          get: {
            info: '/api/corretor',
            contato: '/api/corretor/@cpf/contato',
            produtos: '/api/corretor/produtos',
            produtor: '/api/produtor',
            downloadDeMaterialDeVenda: '/api/corretor/downloadmaterialvenda',
            verificaCadastro: '/api/corretor/verificacadastro',
            verificaEmail: '/api/corretor/verificaremail',
            videos: '/api/corretor/getvideosprodutos',
            videoByUid: '/api/corretor/getvideosbyprodutouid',
            ufs: '/api/corretor/getufsatendidas',
          },
          post: {
            esqueciMinhaSenha: '/api/corretor/{cpf}/esqueci_minha_senha',
            token: '/api/corretor/token',
            cadastro: '/api/corretor',
          },
          put: {
            senha: '/api/corretor/senha',
            dadosPessoais: '/api/corretor/dadospessoais',
            dadosContato: '/api/corretor/dadoscontato',
            equipeVendas: '/api/corretor/equipevendas',
            alterarSenha: '/api/corretor/senha',
          },
        },
        cotacao: {
          get: {
            info: '/api/cotacao',
            faixasEtarias: '/api/cotacao/getfaixaetaria',
            pdf: '/api/cotacao/downloadpropostacotacao',
            pdfUrl: '/api/cotacao/geturldownloadpropostacotacao',
            historico: '/api/cotacao/gethistorico',
            odonto: '/api/cotacao/getmenuodonto',
          },
          post: {
            infoEmpresa: '/api/cotacao',
            grupoCotacao: '/api/cotacao/grupocotacao',
            produtoCotacao: '/api/cotacao/produtocotacao',
          },
          put: {
            update: '/api/cotacao/produtocotacao',
          },
        },
        planos: {
          get: {
            default: '/api/plano/getplanos',
            info: '/api/plano/getinfoplano',
            cobertura: '/api/plano/getcoberturas',
            valorMinimo: '/api/plano/getvalorminimo',
            diferenciais: '/api/plano/getdiferencias',
          },
        },
        pessoa: {
          get: {
            byCpf: '/api/pessoa/cpf',
            byCnpj: '/api/pessoa/cnpj',
          },
        },
        produtor: {
          get: {
            info: '/api/produtor',
          },
        },
        produto: {
          get: {
            list: '/api/corretor/produtos',
            materialVenda: '/api/produto/@id/material_venda',
            materialTreinamento: '/api/produto/@id/material_treinamento',
            banner: '/api/produto/getbannerhome',
          },
        },
        faleConosco: {
          get: {
            info: '/api/faleconosco',
          },
        },
      },
    },
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
